import $ from "jquery";
import "arrive";
import "slick-carousel";

$(document).ready(function () {
  $(".block-halfwidth-numbers-block")
    .parent()
    .each(function () {
      let $slider = $(this);
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
        cssEase: "linear",
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 992,
            settings: "unslick",
          },
        ],
      });
    });
});